import React from 'react';
import { usePortfolio } from '../hooks/usePortfolio';
import { useAuth } from '../hooks/useAuth';
import './PortfolioSummary.css';

const PortfolioSummaryComponent: React.FC = () => {
  const { summary, isLoading, error, settings } = usePortfolio();

  if (isLoading) {
    return (
      <div className="portfolio-summary">
        <div className="loading">포트폴리오 정보를 불러오는 중...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="portfolio-summary">
        <div className="error">포트폴리오 정보를 불러올 수 없습니다: {error}</div>
      </div>
    );
  }

  if (!summary) {
    return (
      <div className="portfolio-summary">
        <div className="no-data">포트폴리오 정보가 없습니다.</div>
      </div>
    );
  }

  const { totalSeed, totalProfitRate, totalDividendRate, totalProfitAmount, totalDividendAmount, dividendYear } = summary;
  
  // 원화일 때 소수점 반올림하여 1의 자리부터 표시
  const formatAmount = (amount: number, currency: string = 'KRW') => {
    if (currency === 'KRW' || !currency) {
      // 원화일 때: 소수점 반올림하여 1의 자리부터 표시
      return Math.round(amount).toLocaleString('ko-KR');
    }
    // 다른 통화일 때: 기존 방식 유지
    return amount.toLocaleString('ko-KR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  
  const currency = settings?.currency || 'KRW';

  return (
    <div className="portfolio-summary">
      <div className="summary-header">
        <h2>포트폴리오 요약</h2>
        <span className="date">{new Date().toLocaleDateString('ko-KR')}</span>
      </div>
      
      <div className="summary-cards">
        <div className="summary-card">
          <div className="card-title">총 시드</div>
          <div className="card-value">
            {totalSeed.toLocaleString()}원
          </div>
        </div>
        
        <div className="summary-card">
          <div className="card-title">총 수익률</div>
          <div className={`card-value ${totalProfitRate >= 0 ? 'positive' : 'negative'}`}>
            {totalProfitRate >= 0 ? '+' : ''}{totalProfitRate.toFixed(2)}%
          </div>
        </div>
        
        <div className="summary-card">
          <div className="card-title">연배당률</div>
          <div className="card-value">
            {totalDividendRate.toFixed(2)}%
          </div>
        </div>
        
        <div className="summary-card">
          <div className="card-title">총 수익금액</div>
          <div className={`card-value ${totalProfitAmount >= 0 ? 'positive' : 'negative'}`}>
            {totalProfitAmount >= 0 ? '+' : ''}{formatAmount(totalProfitAmount, currency)}{currency === 'KRW' ? '원' : ` ${currency}`}
          </div>
        </div>
        
        <div className="summary-card">
          <div className="card-title">총 배당금액{dividendYear ? ` (${dividendYear}년 기준)` : ''}</div>
          <div className="card-value">
            {formatAmount(totalDividendAmount, currency)}{currency === 'KRW' ? '원' : ` ${currency}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioSummaryComponent; 